/*
创建者 魏强(2018.1.30)
中华老字号 banner
*/
<template>
	<div class="focus-warp" id="china-warp" :style="{background:`url(${chinaBanbg})`}" >
	    <div class="swipe-wrap" id="swiper">
	        <div class="swipe" id="swiper-container">
	        	<Carousel
			        v-model="value"
			        :autoplay="setting.autoplay"
			        :autoplay-speed="setting.autoplaySpeed"
			        :dots="setting.dots"
			        :radius-dot="setting.radiusDot"
			        :trigger="setting.trigger"
			        :arrow="setting.arrow"
			        >
			        <CarouselItem v-for="item in data " :key="item.imgUrl">
			        	<router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}">
							<img :src="item.imgUrl" height="412" width="1140" />		
					 	</router-link>
			        </CarouselItem>
			    </Carousel>
			</div>
	    </div>
	</div>
</template>
<script>
import chinaBanbg from '../../assets/images/china/china-banbg.jpg';
export default{
	props:["data"],
	data () {
        return {
        	chinaBanbg,
            value: 0,
            setting: {
                autoplay: true,
                autoplaySpeed: 2000,
                dots: 'inside',
                radiusDot: true,
                trigger: 'hover',
                arrow: "never"
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// banner.vue?00beb0b4